import React, {PureComponent, ReactNode} from "react";
import dekra from "@App/public/assets/images/dekra.png";
import tuevsued from "@App/public/assets/images/tuev-sued.png";
import tuevrheinland from "@App/public/assets/images/tuev-rheinland.png";
import kues from "@App/public/assets/images/kues.png";
import gtue from "@App/public/assets/images/gtue.png";
import tuevnord from "@App/public/assets/images/tuev-nord.png";

type ServiceProviderHintProps = {
    providerId: string,
    hintType: string
    classes: string,
};


export class ServiceProviderHint extends PureComponent<ServiceProviderHintProps> {

    render(): ReactNode {
        const {
            providerId,
            hintType,
            classes
        } = this.props

        const providersizes = {
            'mot': {
                '1': {'width': 90, 'height': 25, 'image': dekra, 'alt': 'DEKRA'},
                '2': {'width': 60, 'height': 60, 'image': tuevsued, 'alt': 'TUEV Sued'},
                '3': {'width': 128, 'height': 110, 'image': tuevrheinland, 'alt': 'TUEV Rheinland'},
                '4': {'width': 70, 'height': 48, 'image': kues, 'alt': 'KUES'},
                '5': {'width': 100, 'height': 50, 'image': gtue, 'alt': 'GTUE'},
                '6': {'width': 70, 'height': 32, 'image': tuevnord, 'alt': 'TUEV Nord'},
            },
            'seperator': {
                '1': {'width': 35, 'height': 10, 'image': dekra, 'alt': 'DEKRA'},
                '2': {'width': 30, 'height': 30, 'image': tuevsued, 'alt': 'TUEV Sued'},
                '3': {'width': 35, 'height': 24, 'image': tuevrheinland, 'alt': 'TUEV Rheinland'},
                '4': {'width': 35, 'height': 24, 'image': kues, 'alt': 'KUES'},
                '5': {'width': 35, 'height': 15, 'image': gtue, 'alt': 'GTUE'},
                '6': {'width': 35, 'height': 16, 'image': tuevnord, 'alt': 'TUEV Nord'},
            },
        }

        const currentProvider = providersizes[hintType as keyof typeof providersizes];
        
        const currentData = currentProvider[providerId as keyof typeof currentProvider];

        return (
            <div className={`${classes}`} style={{height: currentData?.height, width: currentData?.width}}>
                {currentData?.image && (
                    <img
                        loading={'lazy'}
                        src={currentData.image.src}
                        alt={`${currentData.alt}`}
                        width={`${currentData.width}`}
                        height={`${currentData.height}`}
                    />
                )
                }
            </div>
        );
    }
}